/**
 * TEC-509's apply-flow changes (real-salary badge above Apply, confirm-before-marking-applied
 * toast instead of a silent auto-mark) feature-flag cookie name, single-sourced so the backoffice
 * registry and every consumer agree. Managed from `/backoffice/experiments` (see
 * feature-flag-registry.ts) on the shared cookie mechanism in read-feature-flag.ts.
 */
export const APPLY_FLOW_IMPROVEMENTS_COOKIE = 'dev_enable_apply_flow_improvements';
